export default "__VITE_PUBLIC_ASSET__b14f21b8__"